import { useState, useEffect } from "react";
import { Stack, Card, CardContent, Typography, Button } from "@mui/material";
import logo from "../../../assets/main_inverso_sense.svg";

const LOADING_MESSAGES = [
    "Analyzing data, please wait...",
    "Crunching the numbers...",
    "Generating insights...",
    "Almost done, preparing results...",
    "Summarizing findings..."
];

const SenseTechnicalAnalysisCard = ({ technicalAnalysis, isTechnicalAnalysisLoading, handleGenerateAnalysis, thoughtTime }) => {

    const isInitialState = !isTechnicalAnalysisLoading && !technicalAnalysis

    const [loadingMessage, setLoadingMessage] = useState(LOADING_MESSAGES[0]);

    useEffect(() => {
        if (isTechnicalAnalysisLoading) {
            let index = 0;
            const interval = setInterval(() => {
                index = (index + 1) % LOADING_MESSAGES.length;
                setLoadingMessage(LOADING_MESSAGES[index]);
            }, 2500);
            return () => clearInterval(interval);
        }

    }, [isTechnicalAnalysisLoading]);

    return (
        <Card sx={{ borderColor: "primary.main" }}>
            <CardContent>
                <Stack spacing={2} direction={{ xs: "column", lg: "row" }} alignItems={{ xs: "flex-start", lg: "center" }} justifyContent={{ xs: "flex-start", lg: "space-between" }} >
                    <Stack flex={{ xs: 1, lg: 0.75 }} spacing={2} alignItems="flex-start">
                        <Stack spacing={1} direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "center" }} justifyContent="flex-start" >
                            <Typography variant='h4' fontWeight='bold' color="primary">Analyze with</Typography>
                            <img style={{ height: 27.5 }} src={logo} alt='Inverso sense logo' />
                        </Stack>
                        {technicalAnalysis && <Typography color="text.secondary">AI thought for <strong>{thoughtTime}</strong> seconds.</Typography>}
                        <Typography color="text.secondary">
                            {
                                isInitialState ?
                                    "Generate a technical detailed analysis of this investment instrument in seconds powered by our AI." :
                                    isTechnicalAnalysisLoading ?
                                        loadingMessage
                                        :
                                        technicalAnalysis && <Typography
                                            variant="body1"
                                            component="div"
                                            sx={{
                                                whiteSpace: 'pre-wrap', // Keeps line breaks                                                
                                            }}
                                            dangerouslySetInnerHTML={{ __html: technicalAnalysis }}
                                        />
                            }
                        </Typography>

                    </Stack>
                    {
                        isInitialState &&
                        <Button
                            onClick={handleGenerateAnalysis}
                            variant="contained"
                            color="primary"
                        >Generate analysis with AI</Button>
                    }
                </Stack>
            </CardContent>
        </Card>
    )
}

export default SenseTechnicalAnalysisCard;